module.exports = __webpack_public_path__ + "static/media/19.374d4f43.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/res/thumbnails/19.jpg
// module id = 952
// module chunks = 0